import BlogCard from "@/components/BlogCard";
import { blogPosts } from "@/data/blogPosts";

const Blog = () => (
  <main dir="rtl">
    {/* @section: blog-list-page */}
    <section className="py-20 bg-cream"><div className="container-pal"><span className="section-kicker">المدونة</span><h1 className="section-title mt-5">مدونة PalChina</h1><p className="mt-6 max-w-4xl text-xl leading-10 text-muted-foreground">مقالات عربية متخصصة حول الصين والعلاقات الفلسطينية الصينية وفرص التعاون الثقافي والاقتصادي والتعليمي.</p></div></section>
    <section className="py-20 bg-white"><div className="container-pal"><div className="grid gap-7 md:grid-cols-2 lg:grid-cols-3">{blogPosts.map((post)=><BlogCard key={post.slug} post={post}/>)}</div></div></section>
  </main>
);
export default Blog;
